import { tick } from 'svelte';
import { get } from 'svelte/store';

import { JUMP_TYPE_ENUM } from '../enums';
import { AWARD_CD_NUM_SW, TechBtnId } from '../enums/track';
import {
    awardCountdownSecondsLeft,
    isJumpOneLInk,
    activityId,
    isParticipateActivity,
    pageId
} from '../store/index';

import { getOnelinkUrl } from './onelink';
import { trackEvent } from './track';

import { getH5creditCardBaseUrl } from '@/utils/getH5cardLink';
import url from '@/utils/url';

export const getH5creditCardUrl = (params: Record<string, string | number> = {}) => {
    const baseUrl = getH5creditCardBaseUrl();
    const resource = url.get('resource') || window.adv?.getChannelEnv();
    const parseQuery = url.pureParseQuery();
    const urlQuery: Record<string, string> = {
        ...parseQuery,
        resource,
        ...params,
        pageId: get(pageId),
        fromPage: 'web-marketing',
        activityId: get(activityId),
        fromPageId: window?.__PAGE_CONFIG__?.trackingPageId || '',
    };

    // 生成url
    return url.buildUrl(baseUrl, urlQuery);
};

type JumpLinkOptions = {
    awardCountdownNumber?: number;
};

/** 领奖态每次跳转前上报当前倒计时剩余秒数（AWARD_CD_NUM_SW） */
const maybeTrackAwardCountdownBeforeJump = (options?: JumpLinkOptions) => {
    if (!get(isParticipateActivity)) return;

    let num =
        typeof options?.awardCountdownNumber === 'number'
            ? options.awardCountdownNumber
            : get(awardCountdownSecondsLeft);

    if (typeof num !== 'number' || Number.isNaN(num)) {
        num = 0;
    }

    trackEvent(AWARD_CD_NUM_SW, {
        number: Math.max(num, 0)
    });
};

export const JumpLink = async (jumpType: string, options?: JumpLinkOptions) => {
    try {
        isJumpOneLInk.set(true);
        await tick();
        await jumpToJudge(jumpType, options);
    } catch (error) {
        console.error('Conversion error:', error);
    }
};

export const jumpToJudge = async (jumpType: string, options?: JumpLinkOptions) => {
    await tick();

    if (jumpType === JUMP_TYPE_ENUM.TO_H5CREDITCARD) {
        const link = getH5creditCardUrl();

        if (link) {
            maybeTrackAwardCountdownBeforeJump(options);
            trackEvent(TechBtnId.JUMP, {
                url_type: 'creditcard'
            });
            const preloader = window?.preloader as any;

            if (
                preloader &&
                preloader.shouldShowIframe &&
                preloader.shouldShowIframe()
            ) {
                if (preloader.showIframe && preloader.showIframe()) {
                    return;
                }
            }

            window.location.href = link;
        }
    } else {
        const link = getOnelinkUrl();

        maybeTrackAwardCountdownBeforeJump(options);
        trackEvent(TechBtnId.JUMP, {
            url_type: 'onelink'
        });
        if (link) {

            window.location.href = link;
        }
    }
};
